var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpcCallTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 270.547,
    viewBox: "0 0 330.419 270.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3121",
    "data-name": "Group 3121",
    transform: "translate(-92 -3626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    width: 244.838,
    height: 252.548,
    transform: "translate(92.162 3626)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2087",
    "data-name": "Rectangle 2087",
    width: 74.838,
    height: 252.548,
    transform: "translate(347.581 3626)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x2: 244.974,
    transform: "translate(92.026 3666.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x2: 74.393,
    transform: "translate(347.607 3666.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x2: 244.974,
    transform: "translate(92.026 3686.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 74.393,
    transform: "translate(347.607 3686.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 244.974,
    transform: "translate(92.026 3705.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 74.393,
    transform: "translate(347.607 3705.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x2: 244.974,
    transform: "translate(92.026 3724.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 74.393,
    transform: "translate(347.607 3724.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 244.974,
    transform: "translate(92 3743.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 74.393,
    transform: "translate(347.581 3743.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x2: 244.974,
    transform: "translate(92.026 3762.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 74.393,
    transform: "translate(347.607 3762.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x2: 244.974,
    transform: "translate(92.026 3782.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 74.393,
    transform: "translate(347.607 3782.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x2: 244.974,
    transform: "translate(92.026 3801.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x2: 74.393,
    transform: "translate(347.607 3801.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    x2: 244.974,
    transform: "translate(92.026 3820.405)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    x2: 74.393,
    transform: "translate(347.607 3820.405)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    x2: 244.974,
    transform: "translate(92.026 3839.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    x2: 74.393,
    transform: "translate(347.607 3839.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    x2: 244.974,
    transform: "translate(92.026 3858.805)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    x2: 74.393,
    transform: "translate(347.607 3858.805)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M0,0H244.974",
    transform: "translate(92.026 3878.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M0,0H74.419",
    transform: "translate(347.581 3878.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    x2: 244.974,
    transform: "translate(92.026 3647.61)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    x2: 74.419,
    transform: "translate(347.581 3647.61)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec_Avg.",
    "data-name": "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec Avg.",
    transform: "translate(124 3660.182)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.77,
    y: 0
  }, "Jan"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.723,
    y: 19.4
  }, "Feb"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.064,
    y: 38.8
  }, "Mar"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.621,
    y: 58.2
  }, "Apr"), /*#__PURE__*/React.createElement("tspan", {
    x: -22.682,
    y: 77.6
  }, "May"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.857,
    y: 97
  }, "Jun"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.148,
    y: 116.4
  }, "Jul"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.111,
    y: 135.8
  }, "Aug"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.209,
    y: 155.2
  }, "Sep"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.451,
    y: 174.6
  }, "Oct"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.123,
    y: 194
  }, "Nov"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.508,
    y: 213.4
  }, "Dec"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.182,
    y: 232.8
  }, "Avg."))), /*#__PURE__*/React.createElement("text", {
    id: "Patients",
    transform: "translate(385 3641.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.389,
    y: 0
  }, "Patients")), /*#__PURE__*/React.createElement("text", {
    id: "Click_to_Call",
    "data-name": "Click to Call",
    transform: "translate(237 3641.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.086,
    y: 0
  }, "Click to Call")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.",
    "data-name": "Call Conv.",
    transform: "translate(309 3641.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.783,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "Calls",
    transform: "translate(175 3641.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.409,
    y: 0
  }, "Calls")), /*#__PURE__*/React.createElement("text", {
    id: "_25_30_27_23_42_18_25_20_23_34_18_41_26",
    "data-name": "25 30 27 23 42 18 25 20 23 34 18 41 26",
    transform: "translate(173.413 3660.547)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 0
  }, "25"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 19.4
  }, "30"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 38.8
  }, "27"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 58.2
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 77.6
  }, "42"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 97
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 116.4
  }, "25"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 135.8
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 155.2
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 174.6
  }, "34"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "41"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.885,
    y: 232.8
  }, "26"))), /*#__PURE__*/React.createElement("text", {
    id: "_13_14_15_8_12_16_20_15_21_12_10_9_14_",
    "data-name": "13% 14% 15% 8% 12% 16% 20% 15% 21% 12% 10% 9% 14%",
    transform: "translate(237.576 3660.547)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 0
  }, "13%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 19.4
  }, "14%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 38.8
  }, "15%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 58.2
  }, "8%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 77.6
  }, "12%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 97
  }, "16%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 116.4
  }, "20%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 135.8
  }, "15%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 155.2
  }, "21%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 174.6
  }, "12%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 194
  }, "10%"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.764,
    y: 213.4
  }, "9%"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.314,
    y: 232.8
  }, "14%"))), /*#__PURE__*/React.createElement("text", {
    id: "_15_17_21_18_25_30_19_15_21_25_29_30_21_",
    "data-name": "15% 17% 21% 18% 25% 30% 19% 15% 21% 25% 29% 30% 21%",
    transform: "translate(308.86 3660.547)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 0
  }, "15%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 19.4
  }, "17%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 38.8
  }, "21%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 58.2
  }, "18%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 77.6
  }, "25%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 97
  }, "30%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 116.4
  }, "19%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 135.8
  }, "15%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 155.2
  }, "21%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 174.6
  }, "25%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 194
  }, "29%"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 213.4
  }, "30%"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.314,
    y: 232.8
  }, "21%"))), /*#__PURE__*/React.createElement("text", {
    id: "_6_7_8_6_12_6_5_3_4_6_4_12_6.5",
    "data-name": "6 7 8 6 12 6 5 3 4 6 4 12 6.5",
    transform: "translate(385.252 3660.547)",
    fill: "#b94f4f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 19.4
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 38.8
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 58.2
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 77.6
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 97
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 116.4
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 135.8
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 155.2
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 174.6
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 194
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.628,
    y: 232.8
  }, "6.5"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpcCallTable);
export default __webpack_public_path__ + "static/media/ppcCallTable.eabe93c7.svg";
export { ForwardRef as ReactComponent };